import { schema } from 'normalizr'
import { idAttribute, processStrategy } from 'modules/table'

const tableProductOptionBox = new schema.Entity(
  'tableProductOptionBoxes',
  {},
  {
    idAttribute,
    processStrategy,
  }
)

export default tableProductOptionBox
